import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-foundation';
import IconCheckAlt from "../Icon/IconCheckAlt";
import IconExclamationAlt from "../Icon/IconExclamationAlt";
import IconInformationAlt from "../Icon/IconInformationAlt";
var variants = {
  announcement: IconInformationAlt,
  error: IconExclamationAlt,
  informational: IconInformationAlt,
  success: IconCheckAlt,
  warning: IconExclamationAlt
};
var propTypes = {
  variant: PropTypes.oneOf(Object.keys(variants))
};

function Icon(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["variant"]);

  var Component = variants[variant];
  return Component ? React.createElement(Component, Object.assign({
    "aria-hidden": "true"
  }, props), undefined) : null;
}

Icon.propTypes = propTypes;
export default styled(Icon).attrs({
  suppressClassNameWarning: true
}).withConfig({
  displayName: "Icon",
  componentId: "nrue4f-0"
})(["margin-right:", ";"], spacer12);